import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import { DialogContent} from '@mui/material';
import GeneralList from '../GeneralList';


function PopCatheter (props) {
    
    const [chosenCath, setChosenCath] = useState(props.generalCatheter);
    
    function handleClick() {
        props.close();
            }

    function handleSend() {
        props.chosenCatheter(chosenCath);
        
        props.close();

    }

    function addCath(cath, index) {

        const newChosenCath = chosenCath
        newChosenCath.splice(index, 1, cath)
        setChosenCath(newChosenCath)
    }

    return (
    <Dialog
            open={props.open}
            maxWidth="lg"
        >
            <DialogTitle>General anesthesia</DialogTitle>
            <DialogContent dividers>
                <div>
                    <FormControl >
                        <FormGroup >
                            <FormLabel>Catheter</FormLabel>
                            {chosenCath.map((cath, index) => {

                                return (
                                    <GeneralList
                                        key={index}
                                        drug={cath}
                                        index={index}
                                        send={addCath}
                                    />
                                )
                            })}

                        </FormGroup>
                    </FormControl>
                
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={handleClick}>
                    Cancel
                    </Button>
                <Button color="primary" onClick={handleSend}>
                    OK
                    </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PopCatheter;